import { createContext, useContext } from 'react';
import type React from 'react';

/**
 * PD-16919 — what a report page's header shows beside its title, supplied by
 * whatever wraps the report rather than by each report page.
 *
 * The reporting module's layout route provides the current report's favorite
 * star here, so all of the report pages built on ReportPageHeader get it from
 * one place without a change to any of them. Outside that layout (a category
 * page, anything that is not a report) nothing is provided and the header
 * shows nothing extra. Dashboard widgets render a report's content without
 * its page header, so they never show it.
 */
export const ReportPageHeaderSlotContext = createContext<React.ReactNode>(null);

/** The node the enclosing report layout put beside the title, or null. */
export function useReportPageHeaderSlot(): React.ReactNode {
	return useContext(ReportPageHeaderSlotContext);
}
